import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { ResponsiveTableModule } from '@fantaz/shared/directives/responsive-table';
import { SharedPipesDateModule } from '@fantaz/shared/pipes/date';
import { CurrencyModule } from '@fantaz/shared/ui/currency';
import { SharedUiTableComponentModule } from '@fantaz/shared/ui/table-component';
import { PlayButtonModule } from '@fantaz/tournaments/ui/play-button';
import {
  CardDetails,
  CardDetailsActions,
  CardDetailsItem,
  CardDetailsRowBody,
  CardDetailsRowDescription,
  CardDetailsRowTitle,
} from '@fantaz/ui';
import { MobileCardDetails } from './mobile-card-details/mobile-card-details';
import { TournamentsTableViewComponent } from './tournaments-table-view.component';

@NgModule({
  imports: [
    CommonModule,
    MatTableModule,
    MatButtonModule,
    MatIconModule,
    MatSortModule,
    ResponsiveTableModule,
    CurrencyModule,
    PlayButtonModule,
    MatTooltipModule,
    SharedUiTableComponentModule,
    CardDetails,
    CardDetailsItem,
    CardDetailsRowTitle,
    CardDetailsRowDescription,
    MatDividerModule,
    CardDetailsActions,
    RouterModule,
    CardDetailsRowBody,
    SharedPipesDateModule,
    MobileCardDetails,
  ],
  declarations: [TournamentsTableViewComponent],
  exports: [TournamentsTableViewComponent],
})
export class TournamentsTableViewModule {}
